<div class="pageheader">
    <div class="page-title">
        <h1>Tracking document compare</h1>
    </div>
</div>

<div class="fullscreen">
    <app-visual-compare [left]="leftDocumentInfo().content()" [right]="rightDocumentInfo().content()" [language]="language()">
        <ng-container left>
            <ng-template *ngTemplateOutlet="topInfo; context: { $implicit: leftDocumentInfo() }"></ng-template>
            <app-visual-compare-file-info [file]="leftDocumentInfo()" [compareTo]="rightDocumentInfo()" color="#ffa3a3"></app-visual-compare-file-info>
        </ng-container>
        <ng-container right>
            <ng-template *ngTemplateOutlet="topInfo; context: { $implicit: rightDocumentInfo() }"></ng-template>
            <app-visual-compare-file-info [file]="rightDocumentInfo()" [compareTo]="leftDocumentInfo()" color="#d7e8b0"></app-visual-compare-file-info>
        </ng-container>
    </app-visual-compare>
</div>

<ng-template #topInfo let-document>
    <div class="top-info">
        <h2 class="mt-1 mb-1">{{document.labelText}}</h2>
        <h3 class="mt-0 document-info">
            <ep-link linkUrl="/tracking/result/details" [linkParms]="navigationParams(document)">{{document.idText}}</ep-link>
            <span>Input file</span>
            <ep-tracking-status currentStatus="{{document.latestDocumentStatus}}"></ep-tracking-status>
        </h3>
        <app-singleselectbox decorator caption="File" [dataSource]="document.dropDownDataSource" [ngModel]="document.selectedFile()"
            (ngModelChange)="selectFileFromUI(document, $event)" displayExpr="displayName" [grouped]="true" [itemTemplate]="itemTemplate">
            <ng-template #itemTemplate let-data>
                <div class="item-template">
                    <span>{{data.name}}</span>
                    <span>{{data.filename}}</span>
                    <span style="justify-self: end;">Size: {{data.formattedSize}}</span>
                </div>
            </ng-template>
        </app-singleselectbox>
        <app-checkbox decorator="right-side" caption="Additional files" infoText="Include additional files, log files, contexts, saved state and more" [(ngModel)]="includeAdditionalFiles" ></app-checkbox>
    </div>
</ng-template>
